<template lang="html">
    <div class="guese">
        <div class="guese_content" v-for="(m, index) in act.guest" :key="index">
            <div class="guese_teacher">
                <div class="guese_head">
                    <img :src="m.avatar" alt="">
                </div>
                <div class="teacher_introduce">
                    <p class="teacher_name">{{m.name}}</p>
                    <p class="teacher_title">{{m.title}}</p>
                    <p class="teacher_skills">{{m.skills}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            act : [],
        }
    },
    mounted(){
        this.$http({
            url: '/activity/detail?activity_id=18',
            method: 'get',
            params: {
                activity_id : this.$route.query.id,
            },
        }).then( (res) => {
            this.act = res.data;
        })
    },
}
</script>

<style lang="css" scoped>
    .guese{
        width: 100%;
    }
    .guese_content{
        width: 100%;
        padding-top: 25px;
        line-height: 25px;
    }
    .guese_teacher{
        height: 85px;
        display: flex;
    }
    .guese_head img{
        width: 85px;
        height: 85px;
        border-radius: 20px;
        object-fit: cover;
    }
    .teacher_introduce{
        width: 100%;
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .teacher_name{
        font-size: 14px;
        font-weight: 400;
        color: #1F2126;
    }
    .teacher_title{
        max-width: 235px;
        line-height: 15px;
        font-size: 11px;
        color: #606972;
        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
    }
    .teacher_skills{
        font-size: 12px;
        color: #E50120;
        max-width: 240px;
        overflow: hidden;
        word-break:keep-all;
        white-space:nowrap;
    }
</style>
